<template>
  <div class="faq-section-container">
    <page-content-creator
      itemid="wine-faq-list-header"
      pos="top"
      name="wine-faq-list-header"
      allowed-widgets="carousel, vimeo-video"
      class="faq-list-header"
    />
    <b-container>
      <b-row>
        <b-col>
          <page-content-creator
            itemid="wine-faqs-list"
            pos="top"
          />
        </b-col>
      </b-row>
      <b-row class="faq-section">
        <b-col>
          <faq-list :faqs="faqs" />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <page-content-creator
            itemid="wine-faqs-list"
            pos="bottom"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

import { asyncLoader, pageMixin } from '../page-layout-wine-faqs-list-common'
import FaqList from './faq-list'

export default {
  name: 'page-layout-wine-faqs-list',
  components: {
    FaqList
  },
  mixins: [
    pageMixin
  ],
  asyncData: (args) => args.store.dispatch('promisePool', {
    name: 'payge-layout-wine-faqs-list',
    resolve: () => asyncLoader(args)
  })
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';
.faq-list-header {
 ::v-deep .swiper-container{
  margin-bottom:3em;
  }
}
.faq-section-container {
  .faq-section {
    margin: 3em 0 3em 0;
  }
}

</style>
